// extracted by mini-css-extract-plugin
export var boxItems = "_6g-1";
export var boxItemsLg = "_6g-2";
export var button = "_6g-7";
export var buttonLg = "_6g-8";
export var filterGroupBox = "_6g-0";
export var icon = "_6g-3";
export var iconSecondary = "_6g-6";
export var iconWrapper = "_6g-4";
export var iconWrapperLg = "_6g-5";